import { useScrollReveal } from '@/hooks/useScrollReveal';

const conditions = [
  {
    icon: 'ri-briefcase-line',
    label: '雇用形態',
    value: '最初の3ヶ月：業務委託契約\n4ヶ月目以降：正社員登用（予定）',
  },
  {
    icon: 'ri-map-pin-line',
    label: '勤務地',
    value: '高知県（帯屋町周辺、スタジオ確定後に正式通知）',
  },
  {
    icon: 'ri-money-cny-circle-line',
    label: '給与',
    value: '経験・前職給与を考慮のうえ相談',
  },
  {
    icon: 'ri-home-heart-line',
    label: '移住支援',
    value: '東京からの移住者には移住支援補助金の活用サポートあり\n（単身で最大60万円程度）',
  },
  {
    icon: 'ri-building-line',
    label: '事業基盤',
    value: '高知県の補助金（人件費・オフィス賃料）を活用した\n安定した事業基盤',
  },
  {
    icon: 'ri-global-line',
    label: '将来展望',
    value: 'ベトナムをはじめアジアへの横展開も視野に\n成功モデルを作る重要ポジション',
  },
];

export default function ConditionsSection() {
  const { ref: headRef, isVisible: headVisible } = useScrollReveal<HTMLDivElement>();
  const { ref: gridRef, isVisible: gridVisible } = useScrollReveal<HTMLDivElement>();
  const { ref: imgRef, isVisible: imgVisible } = useScrollReveal<HTMLDivElement>();

  return (
    <section id="conditions" className="bg-parchment py-24 md:py-36">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        {/* Section label */}
        <div className="flex items-center gap-4 mb-16">
          <span className="font-sans text-terracotta text-[11px] tracking-[0.4em] uppercase">05</span>
          <div className="flex-1 h-px bg-warm-border" />
          <span className="font-sans text-warm-muted text-[11px] tracking-[0.3em]">Conditions</span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-20 items-start">
          <div>
            <div
              ref={headRef}
              className={`mb-12 transition-all duration-900 ${headVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
            >
              <h2 className="font-serif text-charcoal text-2xl md:text-3xl lg:text-4xl leading-loose">
                働く環境と条件
              </h2>
              <p className="font-sans text-warm-muted text-sm md:text-base leading-loose mt-4">
                高知という場所で、新しいことを始める。
                そのための環境と、安心して挑戦できる条件を用意しています。
              </p>
            </div>

            <div
              ref={gridRef}
              className={`space-y-6 transition-all duration-1000 delay-100 ${gridVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
            >
              {conditions.map((c) => (
                <div key={c.label} className="flex items-start gap-5 py-5 border-b border-warm-border last:border-b-0">
                  <div className="w-10 h-10 flex items-center justify-center flex-shrink-0 bg-cream rounded-full mt-0.5">
                    <i className={`${c.icon} text-terracotta text-lg`} />
                  </div>
                  <div>
                    <p className="font-sans text-warm-muted text-xs tracking-widest uppercase mb-1.5">{c.label}</p>
                    <p className="font-sans text-charcoal text-sm md:text-base leading-relaxed whitespace-pre-line">
                      {c.value}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Kochi image */}
          <div
            ref={imgRef}
            className={`transition-all duration-1000 delay-300 ${imgVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
          >
            <div className="w-full h-80 md:h-[480px] overflow-hidden rounded-lg">
              <img
                src="https://public.readdy.ai/ai/img_res/edited_b482a6e8a18a9e54a326883bdb9eb1e4_72dc5802.jpg"
                alt="高知 帯屋町"
                className="w-full h-full object-cover object-top transition-transform duration-700 hover:scale-105"
              />
            </div>
            <div className="mt-6 p-6 bg-cream rounded-lg">
              <p className="font-serif text-charcoal text-base leading-relaxed">
                「高知で暮らしながら、世界に届くものをつくる。」
              </p>
              <p className="font-sans text-warm-muted text-xs mt-3 leading-loose">
                豊かな自然、温かい人々、リーズナブルな生活費。
                高知は、新しい挑戦をするためのベースとして、思いのほか良い場所です。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
